module.exports = __webpack_public_path__ + "media/images/hero_images/brand-2878-e5e8509a89a55545ef41c72111bd87be.jpg";